<template>
  <v-card>
    <v-card-title>
      Camping
      <v-spacer/>
      <IconButton
        tooltip="Print"
        color="indigo"
        icon="fa-print"
        @click="print()"
      />
      <v-spacer/>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
      />
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="items"
      :search="search"
      hide-actions
      class="elevation-1"
    >
      <template
        slot="items"
        slot-scope="props"
      >
        <td>{{ props.item.campsite }}</td>
        <td>{{ props.item.campsiteCapacity }}</td>
        <td>{{ props.item.campsiteTypeWord }}</td>
        <td>{{ props.item.person || '_______________________________' }}</td>
        <td>{{ props.item.gatePasses || '_____' }}</td>
        <td>{{ props.item.adult || '__' }} - {{ props.item.junior || '__' }} - {{ props.item.child || '__' }}</td>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
// import vuex mapping
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      search: '',
      headers: [
        {
          text: 'CampSite',
          value: 'campsite',
          sortable: false
        },
        {
          text: 'Capacity',
          value: 'campsiteCapacity',
          sortable: false
        },
        {
          text: 'Type',
          value: 'campsiteTypeWord',
          sortable: false
        },
        {
          text: 'Person',
          value: 'person',
          sortable: false
        },
        {
          text: 'Gate Pass',
          value: 'gatePasses',
          sortable: false
        },
        {
          text: 'Party',
          value: 'adult',
          sortable: false
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      gateCampingReport: 'reports/gateCampingReport'
    }),
    items () {
      // concat cells
      return this.gateCampingReport.map((row) => {
        row.campsite = `${row.campgroundName} - ${row.campsiteNumber} ${row.campsiteName}`
        row.person = row.personID ? `${row.lastName}, ${row.firstName} (${row.personID})` : ''
        return row
      })
    }
  },
  methods: {
    print () {
      window.print()
    }
  }
}
</script>
